"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiDataProviderContract = void 0;
const viem_1 = require("viem");
const abis_1 = require("../abis");
class UiDataProviderContract {
    readOnlyContract;
    _publicClient;
    strategyManagerAddress;
    constructor(address, publicClient, strategyManagerAddress) {
        this.readOnlyContract = (0, viem_1.getContract)({
            address: address,
            abi: abis_1.uiDataProviderAbi,
            client: publicClient,
        });
        this._publicClient = publicClient;
        this.strategyManagerAddress = strategyManagerAddress;
    }
    get publicClient() {
        return this._publicClient;
    }
    // ------------------------------ View ------------------------------
    async strategyDataByToken(token) {
        const data = await this.readOnlyContract.read.strategyDataByToken([
            this.strategyManagerAddress,
            token,
        ]);
        return data;
    }
    async userStrategyData(token, user) {
        const strategy = await this.strategyDataByToken(token);
        const data = await this.readOnlyContract.read.userStrategyData([
            strategy.strategyAddress,
            user,
        ]);
        return data;
    }
    async strategyTokenBalances() {
        const balances = await this.readOnlyContract.read.strategiesTokenBalance([
            this.strategyManagerAddress,
        ]);
        return balances;
    }
    async _userQueueWithdrawalRequests(token, user, offset, limit) {
        const strategy = await this.strategyDataByToken(token);
        const data = await this.readOnlyContract.read.userQueueWithdrawalRequests([
            strategy.strategyAddress,
            user,
            offset,
            limit,
        ]);
        return data;
    }
    async userQueueWithdrawalRequests(token, user) {
        const len = await this.userQueueWithdrawalRequestsLen(token, user);
        let offset = 0;
        const limit = 200;
        const requests = [];
        while (offset < len) {
            const _limit = offset + limit > len ? len % limit : limit;
            const _requests = await this._userQueueWithdrawalRequests(token, user, offset, _limit);
            requests.push(..._requests);
            offset += _limit;
        }
        return requests;
    }
    async userQueueWithdrawalRequestsLen(token, user) {
        const strategy = await this.strategyDataByToken(token);
        const len = await this.readOnlyContract.read.userPendingWithdrawalRequestLen([
            strategy.strategyAddress,
            user,
        ]);
        return len;
    }
}
exports.UiDataProviderContract = UiDataProviderContract;
//# sourceMappingURL=UiDataProviderContract.js.map